var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"app-watermark",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"app-watermark-layer",style:(_vm.layerStyle)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }